export default import.meta.ROLLUP_FILE_URL_cp$3vJo41T1cpHN8Y1mXiQ;